import * as React from "react";
import {defineMessages, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {Warning} from "../common/model";
import {createDeleteButtonComponent} from "../common/ui/DeleteButton";
import {actions} from "./actions";
import {AOIMonitor} from "./model";
import InjectedIntlProps = ReactIntl.InjectedIntlProps;

const DeleteButtonComponent = createDeleteButtonComponent();

const mapDispatchToProps = (dispatch, ownProps: DeleteDataButtonProps) => ({
    onDelete: () => {
        return dispatch(actions.deleteNotification(ownProps.data[0].id));
    },
});

interface DeleteDataButtonProps {
    data: AOIMonitor[];
    disabled: boolean;
    onDeleteSuccess: () => void;
    onDelete?: () => Promise<Warning[]>;
    onDeleteError?: () => void;
    onDeleteWarnings: () => void;
    onCloseWarnings?: () => void;
    detail?: boolean;
}

const MESSAGES = defineMessages({
    removeAOIUserHeader: {
        id: "studio.aoi-user.delete-aoi-user-button.delete-aoi-user-header",
        defaultMessage: "Remove {Amount} users",
    },
    removeSingleAOIUserHeader: {
        id: "studio.aoi-user.delete-aoi-user-button.delete-single-aoi-user-header",
        defaultMessage: "Remove user {Title}",
    },
    removeAOIUserBody: {
        id: "studio.aoi-user.delete-aoi-user-button.remove-aoi-user-body",
        defaultMessage: "Are you sure you want to continue?",
    },
    whileRemoveAOIUser: {
        id: "studio.aoi-user.delete-aoi-user-button.while-remove-aoi-user",
        defaultMessage: "Removing user...",
    },
    deleteButton: {
        id: "studio.aoi-user.delete-aoi-user-button.delete-button",
        defaultMessage: "Remove user",
    },
    deleteConfirmationBody:{
        id: "studio.data.delete-data-button.confirmation-body",
        defaultMessage: "Are you sure you want to continue?",
    },
    removeStylesSuccess: {
        id: "studio.aoi-user.delete-aoi-user-button.remove-success",
        defaultMessage: "User successfully removed",
    },
    tooltipMessageNoSelection: {
        id: "studio.aoi-user.delete-aoi-user-button.no-selection-tooltip",
        defaultMessage: "Select user from the list below",
    },
    tooltipMessageOneItemSelection: {
        id: "studio.aoi-user.delete-aoi-user-button.one-item-selection-tooltip",
        defaultMessage: "You don't have permission to delete the user",
    },
    tooltipMessageItemsSelection: {
        id: "studio.aoi-user.delete-aoi-user-button.items-selection-tooltip",
        defaultMessage: "You don't have permission to delete the user",
    },
    buttonTitle: {
        id: "studio.aoi-user.delete-aoi-user-button.delete-aoi-user",
        defaultMessage: "Remove AOI user",
    },
    buttonTitleDetail: {
        id: "studio.aoi-user.delete-aoi-user-button.remove",
        defaultMessage: "Remove",
    },
});

class DeleteDataButtonComponent extends React.Component<DeleteDataButtonProps & InjectedIntlProps> {

    render() {
        const {
            data,
            onDeleteSuccess,
            onDeleteError,
            onDeleteWarnings,
            onCloseWarnings,
            intl,
            disabled,
            detail
        } = this.props;
        let headerText = intl.formatMessage(MESSAGES.removeAOIUserHeader, {Amount: data.length});
        let buttonTitle = intl.formatMessage(MESSAGES.buttonTitle);
        if (data && data.length === 1) {
            if (detail) {
                buttonTitle = intl.formatMessage(MESSAGES.buttonTitleDetail);
            }
            headerText = intl.formatMessage(MESSAGES.removeSingleAOIUserHeader, {Title: data[0].username});
        }
        const tooltipDisabled = this.getTooltipDisabled();

        return <DeleteButtonComponent
            intl={this.props.intl}
            disabled={disabled}
            onDelete={this.props.onDelete}
            onDeleteSuccess={onDeleteSuccess}
            onDeleteError={onDeleteError}
            onDeleteWarnings={onDeleteWarnings}
            onCloseWarnings={onCloseWarnings}
            dialogTitle={headerText}
            buttonTitle={buttonTitle}
            detail={detail}
            tooltipDisabled={tooltipDisabled}
            successMessage={intl.formatMessage(MESSAGES.removeStylesSuccess)}
            executingMessage={intl.formatMessage(MESSAGES.whileRemoveAOIUser)}
            confirmButtonText={intl.formatMessage(MESSAGES.deleteButton)}
            renderConfirmation={() => {
                return (
                    <div>
                        {intl.formatMessage(MESSAGES.deleteConfirmationBody)}
                    </div>
                );
            }}
        />;
    }

    private getTooltipDisabled() {
        const {data, intl} = this.props;
        const noData = !data || data.length === 0;

        if (noData) {
            return intl.formatMessage(MESSAGES.tooltipMessageNoSelection);
        }
        if (data.length === 1) {
            return intl.formatMessage(MESSAGES.tooltipMessageOneItemSelection);
        }
        return intl.formatMessage(MESSAGES.tooltipMessageItemsSelection);
    }

}

export const DeleteAOIUserButton = connect(null, mapDispatchToProps)(injectIntl(DeleteDataButtonComponent));